// import moment from "moment";
import { forwardRef } from "react";
// import { Table } from "reactstrap";
import "./style.scss";
import moment from "moment";
/* eslint-disable */
const ComponentToPrint = forwardRef((props: any, ref: any) => {
  return (
    <div ref={ref} className='m-3'>
      <div className='wrapper' id='printDiv'>
        <section className='invoice page' style={{ padding: 0 }}>
          <div className='row'>
            <div className='col-md-12'>
              <div className='table-responsive' id='tblData'>
                <table
                  className='table table-bordered m-0 test'
                  align='center'
                  style={{
                    borderBottom: "none !important",
                    marginBottom: "0px !important",
                  }}
                >
                  <tbody>
                    <tr>
                      <td width='33%'>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            borderBottom: "1px solid #efefef",
                            paddingBottom: 15,
                          }}
                        >
                          {props.selectedCompany.name}
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            paddingTop: 15,
                          }}
                        >
                          CUSTOMER COPY
                        </div>
                      </td>
                      <td width='33%'>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 45,
                          }}
                        >
                          {moment(props.data.dispatchDate).format("DD-MM-YYYY")}
                        </div>
                      </td>
                      <td width='33%'>
                        <div style={{ textAlign: "left", fontWeight: "bold" }}>
                          DRIVER NAME - {props.data.driverName}
                          <br />
                          VEHICLE NO. - {props.data.vehicleNumber}
                          <br />
                          ROUTE - {props.data.grNumber}
                          <br />
                          TIME - {moment(props.data.createdAt).format("hh:mm A")}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className='data-table table table-bordered table-striped mnc '>
                  <thead>
                    <tr>
                      <th>S.NO.</th>
                      <th>BILL NO.</th>
                      <th>ORDER NO.</th>
                      <th>PARTY NAME</th>
                      <th>CITY</th>
                      <th>BOX</th>
                      <th>SIGN</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data?.invoices?.map((invoice: any, index: number) => {
                      return (
                        <tr>
                          <td>{index + 1}.</td>
                          <td>{invoice.invoiceNumber}</td>
                          <td>{invoice.orderNumber}</td>
                          <td>
                            <td>{invoice.party.name}</td>
                            <br />
                          </td>
                          <td>{invoice?.party?.city?.name}</td>
                          <td>{invoice.checkedNumberOfBox}</td>
                          <td style={{ height: 150 }} width='20%'>
                            &nbsp;
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className='break'></div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='table-responsive'>
                <table
                  className='table table-bordered m-0 test'
                  align='center'
                  style={{
                    borderBottom: "none !important",
                    marginBottom: "0px !important",
                  }}
                >
                  <tbody>
                    <tr>
                      <td width='33%'>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            borderBottom: "1px solid #efefef",
                            paddingBottom: 15,
                          }}
                        >
                          {props.selectedCompany.name}
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            paddingTop: 15,
                          }}
                        >
                          DRIVER COPY
                        </div>
                      </td>
                      <td width='33%'>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 45,
                          }}
                        >
                          {moment(props.data.dispatchDate).format("DD-MM-YYYY")}
                        </div>
                      </td>
                      <td width='33%'>
                        <div style={{ textAlign: "left", fontWeight: "bold" }}>
                          DRIVER NAME - {props.data.driverName}
                          <br />
                          VEHICLE NO. - {props.data.vehicleNumber}
                          <br />
                          ROUTE - {props.data.grNumber}
                          <br />
                          TIME - {moment(props.data.createdAt).format("hh:mm A")}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className='data-table table table-bordered table-striped mnc'>
                  <thead>
                    <tr>
                      <th>S.NO.</th>
                      <th>BILL NO.</th>
                      <th>ORDER NO.</th>
                      <th>PARTY NAME</th>
                      <th>CITY</th>
                      <th>BOX</th>
                      <th>SIGN</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.data?.invoices?.map((invoice: any, index: number) => {
                      return (
                        <tr>
                          <td>{index + 1}.</td>
                          <td>{invoice.invoiceNumber}</td>
                          <td>{invoice.orderNumber}</td>
                          <td>
                            <td>{invoice.party.name}</td>
                            <br />
                          </td>
                          <td>{invoice?.party?.city?.name}</td>
                          <td>{invoice.checkedNumberOfBox}</td>
                          <td style={{ height: 150 }} width='20%'>
                            &nbsp;
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
});

export default ComponentToPrint;
